// src/App.js
import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import Education from "./pages/Education";
import Experience from "./pages/Experience";
import Achievement from "./pages/Achievement";
import FamilyTree from "./pages/FamilyTree";
import Skills from "./pages/Skills";
import Footer from "./components/Footer";

function App() {
  return (
    // src/App.js
    <Router>
      <div className="d-flex flex-column min-vh-100 bg-dark text-white">
        <Navbar />
        <div className="flex-grow-1 py-4">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/education" element={<Education />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/achievement" element={<Achievement />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/family-tree" element={<FamilyTree />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
